import React, { useState, useEffect, useRef } from "react";
import Elements from "./tabbedElement.js";
import { getTabDetails, getAppId } from "../api/core.js";
import { BORDER } from "../../global";

const TabbedSlider = (props) => {
  const mounted = useRef(false);
  const obj = {
    items: [],
    devices: [],
  };
  const [active, setActive] = useState(props.active);
  const setTabs = (event) => {
    event.preventDefault();
    setActive(event.target.getAttribute("data-control"));
  };

  const [tlselem, setTLSElem] = useState(obj);
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  const [telemlsdisplay, setTLSElemDisplay] = useState(false);
  const [orient, setOrient] = useState("");

  useEffect(() => {
    mounted.current = true;
    const TElemDetail = async (app, id) => {
      /* eslint-disable no-unused-vars */

      const result = await getTabDetails(app, id).then(
        (result) => {
          if (mounted.current) {
            setTLSElem(result.data);
            setTLSElemDisplay(result.data.devices[0].itemVisibility);
            setOrient(
              result.data.tabType === "Left" ? "pull-left" : "pull-right"
            );

            if (result.data.items.length === 3) {
              isLoading(false);
            } else {
              isLoading(true);
            }
          }
        },
        (error) => {
          SetError(true);

          isLoading(false);
        }
      );
      /* eslin
      /* eslint-disable no-unused-vars */
    };

    TElemDetail(getAppId(), props.id);
    isLoading(false);
    return () => {
      mounted.current = false;
    };
  }, [props.id]);

  if (telemlsdisplay && !error && !loading) {
    return (
      <div className="container-fluid container-pad">
        <div className="season-tabs tab-right-pad">
          <ul
            className={`nav nav-pills mb-3 ${orient ? orient : "pull-right"}`}
            id="pills-tab"
            role="tablist"
          >
            <li className="nav-item">
              <a
                className={
                  active === "pills-additions"
                    ? BORDER
                      ? "nav-link active"
                      : "nav-link active no-border"
                    : "nav-link"
                }
                data-toggle="pill"
                href="#pills-additions"
                role="tab"
                data-control="pills-additions"
                aria-selected="false"
                onClick={setTabs}
              >
                {tlselem.items[0].itemRef}
              </a>
            </li>
            <li className="nav-item">
              <a
                className={
                  active === "pills-movies"
                    ? BORDER
                      ? "nav-link active"
                      : "nav-link active no-border"
                    : "nav-link"
                }
                data-toggle="pill"
                href="#pills-movies"
                role="tab"
                data-control="pills-movies"
                aria-selected="false"
                onClick={setTabs}
              >
                {tlselem.items[1].itemRef}
              </a>
            </li>
            <li className="nav-item">
              <a
                className={
                  active === "pills-shows"
                    ? BORDER
                      ? "nav-link active"
                      : "nav-link active no-border"
                    : "nav-link"
                }
                data-toggle="pill"
                href="#pills-shows"
                role="tab"
                data-control="pills-shows"
                aria-selected="true"
                onClick={setTabs}
              >
                {tlselem.items[2].itemRef}
              </a>
            </li>
          </ul>
        </div>
        <div className="tab-content tab-top-pad" id="pills-tabContent">
          <div
            id="pills-additions"
            className={
              active === "pills-additions" ? "tab-pane  active" : "tab-pane "
            }
          >
            {tlselem.items[0].itemid !== null ? (
              <Elements
                key={0}
                typed={tlselem.items[0].itemid.elementType}
                ide={tlselem.items[0].itemid._id}
                named={
                  tlselem.items[0].itemid.urlName +
                  Math.floor(Math.random() * 100) +
                  "1"
                }
                index={0}
                inform={tlselem.items[0].itemid}
                {...props}
              ></Elements>
            ) : (
              ""
            )}
          </div>

          <div
            id="pills-movies"
            className={
              active === "pills-movies" ? "tab-pane  active" : "tab-pane"
            }
          >
            {tlselem.items[1].itemid !== null ? (
              <Elements
                key={1}
                typed={tlselem.items[1].itemid.elementType}
                ide={tlselem.items[1].itemid._id}
                named={
                  tlselem.items[1].itemid.urlName +
                  Math.floor(Math.random() * 100) +
                  "2"
                }
                index={1}
                inform={tlselem.items[1].itemid}
                {...props}
              ></Elements>
            ) : (
              ""
            )}
          </div>
          <div
            id="pills-shows"
            className={
              active === "pills-shows" ? "tab-pane active" : "tab-pane"
            }
          >
            {tlselem.items[2].itemid !== null ? (
              <Elements
                key={2}
                typed={tlselem.items[2].itemid.elementType}
                ide={tlselem.items[2].itemid._id}
                named={
                  tlselem.items[2].itemid.urlName +
                  Math.floor(Math.random() * 100) +
                  "3"
                }
                index={2}
                inform={tlselem.items[2].itemid}
                {...props}
              ></Elements>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  } else if (telemlsdisplay && !error && loading) {
    return <div style={{ minHeight: "400px" }}></div>;
  } else {
    return <div></div>;
  }
};

export default TabbedSlider;
